<template>
  <draggable-dialog
     :visible="props.visible"
      top="6vh"
      draggable
      :modal="false"
     :modal-default-height="480"
      modal-class="wps-edit-dialog-xx"
      destroy-on-close
      :close-on-click-modal="false"
      :show-close="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <template #header="">
      <div class="header">
        <h4>做题</h4>
        <div class="right-opera">
<!--          <el-icon
              v-if="!isFull"
              title="全屏"
              @click="isFull = true"
          >
            <FullScreen/>
          </el-icon>

          <el-icon
              v-else
              title="最小化"
              style="opacity: 0.6;position: relative;top: 4px;"
              @click="isFull = false">
            <SemiSelect/>
          </el-icon>-->

          <el-icon
              @click="onClose">
            <Close/>
          </el-icon>
        </div>
      </div>
    </template>

    <div class="content">
      <online-wps-sheet
          ref="onlineOffice"
          class="wps-wrap"
      />
    </div>
  </draggable-dialog>
</template>

<script setup>
import OnlineWpsSheet from '@/components/OnlineWps/sheet'
import DraggableDialog from "@/components/OnlineWps/draggableDialog.vue";
import {Close} from '@element-plus/icons-vue'
import CryptoJS from 'crypto-js';


const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  currentRow: {
    type: Object,
    default: () => {
    }
  }
})

const pageLoading = ref(false)
const onlineOffice = ref()

function onOpen() {
  const fileId = CryptoJS.MD5(props.currentRow.fileUrl).toString() // md5作为fileId
  onlineOffice.value.initWps(fileId, {
    "examStudentInfoId": props.currentRow.examStuInfoId,
    "queId": props.currentRow.queId,
    "isView": 0,
    "scene": "record",
  })
}

function onClose() {
  emit('saved')
  emit('update:visible', false)
}

const emit = defineEmits(['update:visible', 'refresh'])

function closedModal() {
  emit('update:visible', false)
}
</script>

<style lang="scss">
.wps-edit-dialog-xx {
  pointer-events: none;

  .el-dialog {
    pointer-events: auto;

    .header {
      display: flex;
      justify-content: space-between;
      align-content: center;

      > h4 {
        font-size: 18px;
        line-height: 24px;
      }

      .right-opera {
        cursor: pointer;

        .el-icon {
          font-size: 18px;
          margin-left: 15px;

          &:hover {
            color: var(--el-color-primary);
          }

          &:first-child {
            margin-left: 0;
          }
        }
      }
    }

    .content {
      height: 100%;
      .wps-wrap {
        height: 100%;
      }
    }
  }
}
</style>
